const ADJECTIVES = [
  "Adorable",
  "Agile",
  "Alert",
  "Amazing",
  "Amusing",
  "Brave",
  "Bright",
  "Bubbly",
  "Calm",
  "Capable",
  "Carefree",
  "Caring",
  "Charming",
  "Cheerful",
  "Clever",
  "Colorful",
  "Content",
  "Cozy",
  "Courageous",
  "Creative",
  "Cuddly",
  "Curious",
  "Dainty",
  "Daring",
  "Delicate",
  "Delighted",
  "Devoted",
  "Diligent",
  "Eager",
  "Easygoing",
  "Elegant",
  "Enchanting",
  "Energetic",
  "Engaging",
  "Excited",
  "Fair",
  "Fancy",
  "Fantastic",
  "Fast",
  "Fearless",
  "Feisty",
  "Fiery",
  "Fluffy",
  "Friendly",
  "Funny",
  "Gentle",
  "Giddy",
  "Gleaming",
  "Glowing",
  "Golden",
  "Good",
  "Graceful",
  "Grand",
  "Great",
  "Happy",
  "Hardy",
  "Helpful",
  "Honest",
  "Hopeful",
  "Humble",
  "Independent",
  "Ingenious",
  "Inquisitive",
  "Intelligent",
  "Jazzy",
  "Jolly",
  "Joyful",
  "Kind",
  "Lively",
  "Loyal",
  "Lucky",
  "Majestic",
  "Marvelous",
  "Mighty",
  "Modest",
  "Muscular",
  "Nimble",
  "Noble",
  "Optimistic",
  "Patience",
  "Peaceful",
  "Playful",
  "Plucky",
  "Polite",
  "Positive",
  "Powerful",
  "Precise",
  "Pretty",
  "Proud",
  "Quick",
  "Quiet",
  "Radiant",
  "Rapid",
  "Reliable",
  "Resilient",
  "Righteous",
  "Robust",
  "Royal",
  "Sacred",
  "Safe",
  "Silly",
  "Simple",
  "Smart",
  "Smooth",
  "Snappy",
  "Snug",
  "Soft",
  "Soothing",
  "Sparkling",
  "Speedy",
  "Splendid",
  "Sprightly",
  "Spunky",
  "Stellar",
  "Strong",
  "Sturdy",
  "Sunny",
  "Superb",
  "Swift",
  "Sweet",
  "Talented",
  "Tender",
  "Thoughtful",
  "Thrifty",
  "Tidy",
  "Tough",
  "Tranquil",
  "Truthful",
  "Valiant",
  "Vibrant",
  "Vigilant",
  "Warm",
  "Whimsical",
  "Wise",
  "Wonderful",
  "Zany",
  "Zesty",
  "Zooming",
];

const NOUNS = [
  "Aardvark",
  "Albatross",
  "Alligator",
  "Anemone",
  "Ant",
  "Anteater",
  "Antelope",
  "Ape",
  "Armadillo",
  "Badger",
  "Barracuda",
  "Bat",
  "Bear",
  "Beaver",
  "Bee",
  "Beetle",
  "Bird",
  "Bison",
  "Boar",
  "Buffalo",
  "Butterfly",
  "Camel",
  "Canary",
  "Capybara",
  "Caracal",
  "Cat",
  "Caterpillar",
  "Chameleon",
  "Cheetah",
  "Chicken",
  "Chimpanzee",
  "Chinchilla",
  "Chipmunk",
  "Clam",
  "Cobra",
  "Cockroach",
  "Cod",
  "Condor",
  "Coral",
  "Cougar",
  "Cow",
  "Coyote",
  "Crab",
  "Crane",
  "Cricket",
  "Crocodile",
  "Crow",
  "Deer",
  "Dingo",
  "Dog",
  "Dolphin",
  "Donkey",
  "Dove",
  "Dragonfly",
  "Duck",
  "Eagle",
  "Eel",
  "Elephant",
  "Elk",
  "Emu",
  "Falcon",
  "Ferret",
  "Finch",
  "Fish",
  "Flamingo",
  "Flea",
  "Fly",
  "Fox",
  "Frog",
  "Gazelle",
  "Gecko",
  "Gerbil",
  "Giraffe",
  "Goat",
  "Goose",
  "Gorilla",
  "Gopher",
  "Hawk",
  "Hedgehog",
  "Heron",
  "Hippopotamus",
  "Hornet",
  "Horse",
  "Hummingbird",
  "Hyena",
  "Impala",
  "Insect",
  "Jaguar",
  "Jellyfish",
  "Kangaroo",
  "Kingfisher",
  "Koala",
  "Komodo Dragon",
  "Kookaburra",
  "Ladybug",
  "Lemur",
  "Leopard",
  "Lion",
  "Lizard",
  "Llama",
  "Lobster",
  "Lynx",
  "Macaw",
  "Magpie",
  "Mallard",
  "Mantis",
  "Marten",
  "Meerkat",
  "Mink",
  "Mole",
  "Mongoose",
  "Monkey",
  "Moose",
  "Mosquito",
  "Moth",
  "Mouse",
  "Mule",
  "Newt",
  "Octopus",
  "Okapi",
  "Opossum",
  "Orangutan",
  "Ostrich",
  "Otter",
  "Owl",
  "Ox",
  "Panda",
  "Panther",
  "Parrot",
  "Peacock",
  "Pelican",
  "Penguin",
  "Pheasant",
  "Pig",
  "Pigeon",
  "Piranha",
  "Platypus",
  "Polar Bear",
  "Pony",
  "Porcupine",
  "Porpoise",
  "Puma",
  "Quail",
  "Rabbit",
  "Raccoon",
  "Ram",
  "Rat",
  "Rattlesnake",
  "Raven",
  "Reindeer",
  "Rhinoceros",
  "Robin",
  "Rooster",
  "Salamander",
  "Salmon",
  "Sandpiper",
  "Sardine",
  "Scorpion",
  "Seal",
  "Shark",
  "Sheep",
  "Shrimp",
  "Skunk",
  "Sloth",
  "Snail",
  "Snake",
  "Sparrow",
  "Spider",
  "Squid",
  "Squirrel",
  "Starfish",
  "Stingray",
  "Stork",
  "Swallow",
  "Swan",
  "Tapir",
  "Tarsier",
  "Tiger",
  "Toad",
  "Toucan",
  "Turkey",
  "Turtle",
  "Walrus",
  "Wasp",
  "Weasel",
  "Whale",
  "Wolf",
  "Wolverine",
  "Wombat",
  "Woodpecker",
  "Worm",
  "Yak",
  "Zebra",
];

export function generateNickname() {
  const adjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  const number = Math.floor(Math.random() * 1000);
  return `${adjective}-${noun}-${number}`;
}
